import { clearFilters, getFiltersByFilterTypes, getFiltersValues } from "./filters/index";

export const populateListItems = (el, elementClassName) => {
    const listItemsElements = el.querySelectorAll(elementClassName);

    if (listItemsElements.length === 0) return;

    const listItems = [];

    for (const listItem of listItemsElements) {
        listItems.push({
            element: listItem,
            ...listItem.dataset,
        });
    }

    return listItems;
};

export const toggleListItemClass = (listItem, classState) =>
    listItem.element.parentElement.classList[classState]("el__item--active");

export const toggleListItemsClass = (listItems, classState) => {
    for (const listItem of listItems) {
        toggleListItemClass(listItem, classState);
    }
};

export const convertValueToInteger = (value) => {
    if (!value) return null;

    if (typeof value !== "string") return value;

    const integer = parseInt(value, 10);

    return !isNaN(integer) ? integer : value;
};

export const convertObjectStringValuesToIntegers = (obj) => {
    for (const [key, value] of Object.entries(obj)) {
        const updatedValue = convertValueToInteger(value);
        obj[key] = updatedValue;
    }
};

export const toggleNoResultsEl = (noResultsEl, filteredExtensionsCount) => {
    if (!noResultsEl) return;

    const classState = filteredExtensionsCount === 0 ? "add" : "remove";

    noResultsEl.classList[classState]("el__no-results--active");
};

export const addClearFiltersEventListener = (clearFiltersEls, state) =>
    clearFiltersEls.forEach((el) => {
        const filterTypes = el.dataset.filterTypes ? el.dataset.filterTypes.split(",") : [];

        if (filterTypes.length === 0) return;

        let filteredFilters = getFiltersByFilterTypes(state.filters, filterTypes);

        if (Object.keys(filteredFilters).length === 0) return;

        el.addEventListener("click", clearFilters.bind(null, state, filteredFilters));
    });

export const toggleClearFiltersEls = (clearFiltersEls, filters) =>
    clearFiltersEls.forEach((el) => {
        const filterTypes = el.dataset.filterTypes ? el.dataset.filterTypes.split(",") : [];

        if (filterTypes.length === 0) return;

        const filtersValues = getFiltersValues(filters, filterTypes);

        const classState = filtersValues.length === 0 ? "remove" : "add";

        el.classList[classState]("el__clear-filters--active");
    });
